import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {ICompetition} from '@components/competitions/ICompetitions';
import {appConfig} from '@config';
import {CompetitionMuharramContext} from '@context/CompetitionMuharramContext';
import {Box} from '@mui/material';
import socketCompetition from '@sockets/competition';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useLocation} from 'react-router-dom';
import Mission0 from './Mission0';

// Type for nested answer map
type AnswerMap = {
	[day: number]: {
		[question: number]: number | null;
	};
};

const now: Date = new Date();
const currentDate: number = now.getDate();

export default function Muharram() {
	let referrer = '',
		socialGroup = '';
	const {t} = useTranslation();
	const location = useLocation();
	
	if (location.state) {
		referrer = location.state?.referrer ?? '';
		if (referrer === 'shad') {
			socialGroup = 'shad';
		}
	}
	
	const [competition, setCompetition] = useState<ICompetition>({});
	const [mission, setMission] = useState<number>(0);
	const [phone, setPhone] = useState<string>('');
	const [answers, setAnswers] = useState<AnswerMap>({});
	const [day, setDay] = useState<number>(currentDate);
	
	const competitionObject = useLoaderData() as ICompetition;
	
	useEffect(() => {
		socketCompetition.connect();
	}, []);
	
	useEffect(() => {
		setCompetition(competitionObject);
	}, [competitionObject]);
	
	useEffect(() => {
		const savedAnswers = localStorage.getItem('muharram_answers');
		if (savedAnswers) {
			try {
				setAnswers(JSON.parse(savedAnswers));
			} catch (e) {
				console.error('Invalid saved answers format');
			}
		}
	}, []);
	
	return (
		<CompetitionMuharramContext.Provider
			value={{
				competition,
				mission,
				setMission,
				phone,
				setPhone,
				day,
				setDay,
				answers,
				setAnswers
			}}
		>
			<Box className="w-full flex justify-center flex-col">
				<HeaderWithIcons
					title={competition.name ?? 'مسابقه بزرگ "برنده باش"!'}
					home={true}
					backUrl={'/'}
				/>
				<Box
					className="muharram-bg flex flex-col w-full h-[calc(100vh-55px)] bg-repeat overflow-y-scroll justify-center">
					<Mission0/>
				</Box>
			</Box>
		</CompetitionMuharramContext.Provider>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function wordsLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition2.url}muharram/${data.params.competitionId}`,
		method: 'GET'
	});
	
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
